import { Messages } from "@/types";

const THINKING_BLOCK_PATTERN = /<think>[\s\S]*?<\/think>/g;

const findLastAssistantIndex = (messages: Messages) => {
  for (let index = messages.length - 1; index >= 0; index--) {
    if (messages[index].role === "assistant") {
      return index;
    }
  }

  return -1;
};

export const preserveStreamedThinking = (
  persistedMessages: Messages,
  streamedMessages: Messages,
): Messages => {
  const persistedAssistantIndex = findLastAssistantIndex(persistedMessages);
  const streamedAssistantIndex = findLastAssistantIndex(streamedMessages);

  if (persistedAssistantIndex === -1 || streamedAssistantIndex === -1) {
    return persistedMessages;
  }

  const persistedContent =
    persistedMessages[persistedAssistantIndex].content;
  const streamedContent = streamedMessages[streamedAssistantIndex].content;

  if (
    typeof persistedContent !== "string" ||
    typeof streamedContent !== "string" ||
    persistedContent.includes("<think>")
  ) {
    return persistedMessages;
  }

  const thinkingBlocks = streamedContent.match(THINKING_BLOCK_PATTERN);
  if (!thinkingBlocks?.length) {
    return persistedMessages;
  }

  const separator = persistedContent ? "\n\n" : "";
  const nextMessages = [...persistedMessages];
  nextMessages[persistedAssistantIndex] = {
    ...persistedMessages[persistedAssistantIndex],
    content: `${thinkingBlocks.join("\n\n")}${separator}${persistedContent}`,
  };

  return nextMessages;
};
